import {FractionalUnits} from '@mintdata/mint-kit/api/models/FractionalUnits';
import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {
    FractionalUnitsConverter,
    FractionalUnitsStringConverter,
    SimpleFractionalUnitsConverter
} from '@mintdata/mint-kit/impl/properties/converters/FractionalUnitsConverter';
import {FractionalUnitsEditor} from '@mintdata/mint-kit/impl/properties/editors/FractionalUnitsEditor';
import {FractionalUnitsStringEditor} from '@mintdata/mint-kit/impl/properties/editors/FractionalUnitsStringEditor';

export const FractionalSimpleUnitsConfig:IPropertyTypeConfig<FractionalUnits> =
    {
        converter: SimpleFractionalUnitsConverter,
        editor: FractionalUnitsStringEditor
    };

export const FractionalUnitsStringConfig:IPropertyTypeConfig<AString> =
    {
        converter: FractionalUnitsStringConverter,
        editor: FractionalUnitsStringEditor
    };

export const FractionalUnitsConfig:IPropertyTypeConfig<FractionalUnits> =
    {
        converter: FractionalUnitsConverter,
        editor: FractionalUnitsEditor
    };
